import React from "react";
import classNames from "classnames";
import { isSplit } from "shared/utils/validation";
import {
  calculateScoreDifferences,
  getLastFourElementsWithData,
} from "./utils";
import styles from "./styles.module.scss";

const StrikeOrSpare = ({ score, isTenthFrame, isSplit = false }) => {
  if (score === "X")
    return <span style={{ width: isTenthFrame ? "50%" : "100%" }}>X</span>;
  if (score === "/") return <span className={styles.spare}>/</span>;
  return (
    <span className={classNames(styles.throw, { [styles.is_split]: isSplit })}>
      {score}
    </span>
  );
};

const RenderScoreCompacted = ({ throws, index, pins, scores }) => {
  const firstThrow = throws[index * 2];
  const secondThrow = throws[index * 2 + 1];
  const firstPin = pins[index * 2];
  const secondPin = pins[index * 2 + 1];

  if (!firstThrow && !secondThrow) return <td></td>;
  if (scores[index] !== undefined)
    return <td className={styles.td_render_score}>{scores[index]}</td>;

  return (
    <td className={styles.td_render_score}>
      <span className={styles.render_score}>
        <StrikeOrSpare
          score={firstThrow}
          isTenthFrame={throws.length >= 19}
          isSplit={isSplit(firstPin)}
        />
        {secondThrow && (
          <StrikeOrSpare
            score={secondThrow}
            isTenthFrame={throws.length >= 19}
            isSplit={isSplit(secondPin)}
          />
        )}
      </span>
    </td>
  );
};

export default function PBAScoreCompacted({ players, numberOfPlayers }) {
  const size = players.size;
  const frames = getLastFourElementsWithData(players);
  const scoreDifferences = calculateScoreDifferences(players);

  return (
    <div className={styles.container}>
      <table className={styles.table_compacted}>
        <thead>
          <tr className={styles.tr_thead}>
            <td></td>
            {frames.map((frame) => (
              <td key={`frame-${frame}`}>{frame + 1}</td>
            ))}
            <td>MAX</td>
          </tr>
        </thead>
        <tbody>
          {Array.from(players)
            .slice(0, numberOfPlayers)
            .map(([key, player], rowIndex) => (
              <React.Fragment key={key}>
                <tr>
                  <td className={styles.td_body_first}>
                    <div className={styles.td_body_first_container}>
                      <p className={styles.player_name}>{player.playerName}</p>
                      {rowIndex < size - 1 && (
                        <span>{scoreDifferences[rowIndex]}</span>
                      )}
                    </div>
                  </td>
                  {frames.map((frame) => (
                    <RenderScoreCompacted
                      key={`${player.playerName}-${frame}`}
                      index={frame}
                      throws={player.throws}
                      pins={player.pins}
                      scores={player.scores}
                    />
                  ))}
                  <td>{player.maxScore}</td>
                </tr>
              </React.Fragment>
            ))}
        </tbody>
      </table>
    </div>
  );
}
